"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeQueryParameters = void 0;
function serializeQueryParameters(queryParameters) {
    return Object.keys(queryParameters)
        .filter(function (key) { return queryParameters[key]; })
        .map(function (key) { return key + "=" + queryParameters[key]; })
        .join("&");
}
exports.serializeQueryParameters = serializeQueryParameters;
